var KlaviyoSubscribeHero = function () {

    KlaviyoSubscribe.attachToForms('[data-hero-signup]', {
        hide_form_on_success: true,
        success: function (form) {
            console.log("FORM", form);
            if(form.style === undefined) {
                if(form[0]) {
                    form[0].style.display = 'none';
                    form[0].nextElementSibling.style.display = 'block'
                }
            }
            else {
                form.style.display = 'none';
                form.nextElementSibling.style.display = 'block'
            }
        },
        extra_properties: {
            $source: '$embed',
            $method_type: "Klaviyo Form",
            $method_id: 'embed'
        }
    });
}();